import React, { useEffect, useState } from "react";
import AlertHome from "./alertHOme";

function SystemStatusCard() {
    const [alerts, setAlerts] = useState([]);

    const [status, setStatus] = useState({
        online: false,
        uptime: "Loading..."
    });

    const [previousStatus, setPreviousStatus] = useState(null);

    const addAlert = (message, type) => {
        const id = Date.now() + Math.random();
        const newAlert = { id, message, type };
        setAlerts(prev => [...prev, newAlert]);

        // Auto remove after 3 seconds
        setTimeout(() => {
            setAlerts(prev => prev.filter(alert => alert.id !== id));
        }, 3000);
    };

    const removeAlert = (id) => {
        setAlerts(prev => prev.filter(alert => alert.id !== id));
    };

    const fetchStatus = async () => {
        try {
            const res = await fetch("/api/system_status");
            const data = await res.json();

            const currentOnline = true;

            setStatus({
                online: true,
                uptime: data.formatted
            });

            if (previousStatus !== null && previousStatus !== currentOnline) {
                addAlert("Server Online", "success");
            }

            setPreviousStatus(currentOnline);

        } catch (error) {

            const currentOnline = false;

            setStatus({
                online: false,
                uptime: "Server Offline"
            });

            if (previousStatus !== null && previousStatus !== currentOnline) {
                addAlert("Server Offline", "danger");
            }

            setPreviousStatus(currentOnline);
        }
    };

    useEffect(() => {
        fetchStatus();
        const interval = setInterval(fetchStatus, 5000); // every 5 seconds
        return () => clearInterval(interval);
    }, [previousStatus]);

    return (
        <>
            {alerts.map((alert, index) => (
                <AlertHome
                    key={alert.id}
                    show={true}
                    message={alert.message}
                    type={alert.type}
                    onClose={() => removeAlert(alert.id)}
                    style={{ top: `${10 + index * 70}px` }}
                />
            ))}

            <div className="card-body">
                <h5 className="card-title">
                    System Status
                    <span style={{ color: status.online ? "green" : "red" }}>
                        {" | "}
                        <i className={`bi bi-circle-fill activity-badge ${status.online ? "text-success" : "text-danger"}`}></i>
                        {status.online ? " ONLINE" : " OFFLINE"}
                    </span>
                </h5>

                <div className="d-flex align-items-center">
                    <div>
                        <strong>Uptime:</strong> {status.uptime}
                    </div>
                </div>
            </div>
        </>
    );
}

export default SystemStatusCard;